export const SET_LAN = 'SET_LAN'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js